export const GET_PROMOTIONS = 'GIFTYA/GET_PROMOTIONS';
export const getPromotions = (payload, meta = {}, error = false) => ({
    type: GET_PROMOTIONS,
    payload,
    meta,
    error
});